import { render, staticRenderFns } from "./TemplateMaterialEdit.vue?vue&type=template&id=53f04c28&"
import script from "./TemplateMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports